import React from "react";
import ReconcilliationTable from "./View/ReconcilliationTable";

interface IProps {}
export const ReconcilliationQueue: React.FC<IProps> = ({}) => {
  return (
    <>
      <ReconcilliationTable />
    </>
  );
};
